
import Root from "./Root"
import HomeBranding from '../pages/HomeBranding.vue'
import NotFound from '../pages/elements/404.vue'
import PageEquipements from '../pages/PageEquipements.vue'
import PageLogiciels from '../pages/PageLogiciels.vue'
import PageEncreMedias from '../pages/PageEncreMedias.vue'
// import PageArtGraphic from '../pages/PageArtGraphic.vue'
import PageServices from '../pages/PageServices.vue'
import PageSoumission from '../pages/PageSoumission.vue'
import PageRemerciement from '../pages/PageRemerciement.vue'
import PrinterLandingPage from '../pages/PrinterLandingPage.vue'
import imprimantesHpLatex from '../pages/ImprimantesHpLatex.vue'
import imprimantesHpLatex530 from '../pages/ImprimantesHpLatex530.vue'
import imprimantesHpLatex630 from '../pages/ImprimantesHpLatex630.vue'
import imprimantesHpLatex700800 from '../pages/ImprimantesHpLatex700800.vue'
import imprimantesHpLatex10002000 from '../pages/ImprimantesHpLatex10002000.vue'
import imprimantesHpPagewide from '../pages/ImprimantesHpPagewide.vue'

import imprimantesWaxjet510 from '../pages/ImprimantesWaxjet510.vue'

import printing3D from '../pages/3DPrinting.vue'
import partner from '../pages/Partner.vue'
import buyer from '../pages/Buyer.vue'
import talentExpert from '../pages/TalentExpert.vue'
import jewelry from '../pages/Jewelry.vue'
import demo from '../pages/Demo.vue'
import wj51c from '../pages/WJ51C.vue'

export const routes = [
	{
		path:'/',
		component: Root,
		children:[
			{
				path:'',
				name: 'GroupeAA',
				component: HomeBranding
			},
			{
				path:'/imprimantes-art-graphique',
				name: 'Équipements',
				component: PageEquipements
			},
			{
				path:'/logiciels',
				name: 'PageLogiciels',
				component: PageLogiciels
			},
			{
				path:'/medias-et-encres',
				name: 'PageEncreMedias',
				component: PageEncreMedias
			},
			{
				path:'/service',
				name: 'Services',
				component: PageServices
			},
			{
				path:'/contactez-nous',
				name: 'ContactUs',
				component: PageSoumission
			},
			{
				path:'/remerciement',
				name: 'Remerciement',
				component: PageRemerciement
			},
			{
				path:'/imprimantes-hp-serie-z-designjet',
				name: 'PrinterLandingPage',
				component: PrinterLandingPage
			},
			{
				path:'/imprimantes-hp-latex',
				name: 'PrinterLatexLandingPage',
				component: imprimantesHpLatex
			},
			{
				path:'/imprimantes-hp-latex-R530',
				name: 'PrinterLatex530LandingPage',
				component: imprimantesHpLatex530
			},
			{
				path:'/impression-3d',
				name: 'Printing3DLandingPage',
				component: printing3D
			},
			{
				path:'/impression-3d/partenaire',
				name: 'PartnerLandingPage',
				component: partner
			},
			{
				path:'/impression-3d/acheteur',
				name: 'BuyerLandingPage',
				component: buyer
			},
			{
				path:'/impression-3d/talent-expert',
				name: 'TalentExpertLandingPage',
				component: talentExpert
			},
			{
				path:'/impression-3d/bijoux',
				name: 'JewelryLandingPage',
				component: jewelry
			},
			{
				path:'/impression-3d/demonstration-virtuelle',
				name: 'DemoLandingPage',
				component: demo
			},
			{
				path:'/impression-3d/flashforge-wj51c-imprimante-3d-cire',
				name: 'WJ51CLandingPage',
				component: wj51c
			},
			{
				path:'/imprimantes-waxjet-510',
				name: 'PrinterWaxjet510LandingPage',
				component: imprimantesWaxjet510
			},
			{
				path:'/imprimantes-hp-latex-630',
				name: 'PrinterLatex630LandingPage',
				component: imprimantesHpLatex630
			},
			{
				path:'/imprimantes-hp-latex-700-800',
				name: 'PrinterLatex700800LandingPage',
				component: imprimantesHpLatex700800
			},
			{
				path:'/imprimantes-hp-latex-1000-2000',
				name: 'PrinterLatex10002000LandingPage',
				component: imprimantesHpLatex10002000
			},
			{
				path:'/imprimantes-hp-pagewide',
				name: 'PrinterWideLandingPage',
				component: imprimantesHpPagewide
			},
			{
				path: '/:lang(en)',
				component: Root,
				children: [
					{
						path:'/:lang(en)',
						name: 'GroupeAA en',
						component: HomeBranding
					},
					{
						path:'/:lang(en)/graphic-art-printers',
						name: 'Équipements en',
						component: PageEquipements
					},
					{
						path:'/:lang(en)/softwares',
						name: 'PageLogiciels en',
						component: PageLogiciels
					},
					{
						path:'/:lang(en)/ink-and-media',
						name: 'PageEncreMedias en',
						component: PageEncreMedias
					},
					{
						path:'/:lang(en)/services',
						name: 'Services en',
						component: PageServices
					},
					{
						path:'/:lang(en)/contact-us',
						name: 'ContactUs en',
						component: PageSoumission
					},
					{
						path:'/:lang(en)/thank-you',
						name: 'Remerciement en',
						component: PageRemerciement
					},
					{
						path:'/:lang(en)/hp-designjet-z-series-printers',
						name: 'PrinterLandingPage en',
						component: PrinterLandingPage
					},
					{
						path:'/:lang(en)/printers-hp-latex',
						name: 'PrinterLatexLandingPage en',
						component: imprimantesHpLatex
					},
					{
						path:'/:lang(en)/printers-hp-latex-R530',
						name: 'PrinterLatex530LandingPage en',
						component: imprimantesHpLatex530
					},
					{
						path:'/:lang(en)/printers-waxjet-510',
						name: 'PrinterWaxJet510LandingPage en',
						component: imprimantesWaxjet510
					},
					{
						path:'/:lang(en)/3d-printing',
						name: 'Printing3DLandingPage en',
						component: printing3D
					},
					{
						path:'/:lang(en)/3d-printing/partner',
						name: 'PartnerLandingPage en',
						component: partner
					},
					{
						path:'/:lang(en)/3d-printing/buyer',
						name: 'BuyerLandingPage en',
						component: buyer
					},
					{
						path:'/:lang(en)/3d-printing/talent-expert',
						name: 'TalentExpertLandingPage en',
						component: talentExpert
					},
					{
						path:'/:lang(en)/3d-printing/jewelry',
						name: 'JewelryLandingPage en',
						component: jewelry
					},
					{
						path:'/:lang(en)/3d-printing/virtual-demonstration',
						name: 'DemoLandingPage en',
						component: demo
					},
					{
						path:'/:lang(en)/3d-printing/flashforge-wj51c-3d-wax-printer',
						name: 'WJ51CLandingPage en',
						component: wj51c
					},
					{
						path:'/:lang(en)/printers-hp-latex-630',
						name: 'PrinterLatex630LandingPage en',
						component: imprimantesHpLatex630
					},
					{
						path:'/:lang(en)/printers-hp-latex-700-800',
						name: 'PrinterLatex700800LandingPage',
						component: imprimantesHpLatex700800
					},
					{
						path:'/:lang(en)/printers-hp-latex-1000-2000',
						name: 'PrinterLatex10002000LandingPage',
						component: imprimantesHpLatex10002000
					},
					{
						path:'/:lang(en)/printers-hp-pagewide',
						name: 'PrinterWideLandingPage en',
						component: imprimantesHpPagewide
					},
					{
						path:'/:lang(en)/*',
						name: 'NotFound fr en',
						component: NotFound
					}
				]
			},
			{
				path:'/*',
				name: 'NotFound fr',
				component: NotFound
			},
		]
	},
	{
		path:'*',
		name: 'NotFound fr en en',
		component: NotFound
	}
];